<div class="header-report__dropdown">
    <drop-down
        #dropDown
        [selectedTemplate]="selectedOption"
        [optionsTemplate]="filterOption"
        [mobileCenter]="true"
    >
        <div *ngIf="!selectedReport"  class="header-report__item">{{"dashboard.filter.selectFilter" | i18next}}</div>
        <div *ngIf="selectedReport" class="header-report__item" [title]="selectedReport.name">
            <div class="txt-sm header-report__label">{{selectedReport.name}}</div>
        </div>
    </drop-down>
</div>

<ng-template #selectedOption >
    <div *ngIf="!selectedReport"  class="header-report__item">{{"dashboard.filter.selectFilter" | i18next}}</div>
    <div *ngIf="selectedReport" class="header-report__item" [title]="selectedReport.name">
        <div class="txt-sm header-report__label">{{selectedReport.name}}</div>
    </div>
</ng-template>

<ng-template #filterOption >
    <div class="header-report__dropdown-list-container">
        <div class="header-report__dropdown-list">
            <div class="header-report__item" *ngFor="let filter of filters" [class.selected]="isSelectedFilters(filter.id)">
                <div class="txt-sm header-report__label" (click)="selectSavedFilter(filter)">{{filter.name}}</div>
                <div class="header-report__btn-list" [class.active]="isDefaultReport(filter.id)">
                    <span class="txt-xs header-report__btn header-report__bordered-btn  default-btn" [class.loading]="loading" (click)="makeDefaultSavedFilter(filter.id, $event)">
                        {{ (isDefaultReport(filter.id) ? 'analytics.reports.default': 'analytics.reports.setDefault') | i18next }}
                    </span>
                    <i class="fa fa-trash header-report__btn slide-btn" (click)="openModal(modalComponent, filter)"></i>
                </div>
            </div>
            <div class="header-report__item" *ngIf="!filters.length">
                <div class="txt-sm header-report__label">{{'dashboard.filter.dontHaveSavedFilters' | i18next}}</div>
                
            </div>
        </div>
    </div>
    
    <div class="header-report__modal-overlay" (click)="closeDropdown($event)"></div>
</ng-template>

<ng-template #emptyFilterList>
    <div class="save-filter__empty-list">
        <i class="icn icn-empty-state-icon"></i>
        {{'analytics.reports.savedFilters.emptyList' | i18next}}
    </div>
</ng-template>

<modal #modalComponent>
    <div class="save-filter__dialog">
        <p class="txt-md">{{'analytics.reports.savedFilters.modal.questionText' | i18next}}</p>
        <div class="save-filter__btns">
            <span class="button button--small button--primary-inverted" (click)="approveRemove(modalComponent)">{{'common.yes' | i18next}}</span>
            <span class="button button--small button--cancel" (click)="closeModal(modalComponent);">{{'common.no' | i18next}}</span>
        </div>
    </div>
</modal>
